export const routes = (parentName) => {
  return [
    {
      path: "my-events",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-MyEvents`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-MyEvents-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "MyEvents-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "MyEvents-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
